(() => {
  const params = new URLSearchParams(location.search);
  const designer = params.get('designer');
  const model = params.get('model');
  const source = params.get('source');
  const brand = document.getElementById('od-brand');
  const style = document.getElementById('od-style');
  if (!brand || !style || (!designer && !model)) return;
  if (designer) {
    const option = [...brand.options].find(o => o.value.toLowerCase() === designer.toLowerCase());
    if (option) brand.value = option.value;
  }
  if (model) style.value = model;
  const notes = document.getElementById('od-notes');
  if (source && notes && source.startsWith('/products/')) notes.value = 'Looking for a similar piece: ' + location.origin + source;
})();
